// extracted by mini-css-extract-plugin
export default {"wrap":"yG-z","subtitle":"zG-z","contentWrap":"AG-z","imgWrap":"BG-z","heading":"CG-z","copy":"DG-z"};